import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { RouterLink } from '@angular/router'

import { BaseComponent } from '../../shared'

interface StatusBucket {
    status: string
    count: number
    total: number
}

interface PurchasingMetrics {
    totalOrders: number
    openOrders: number
    totalOrderValue: number
    pendingInvoices: number
    unmatchedInvoices: number
    openQuotes: number
    cleanMatches: number
    varianceMatches: number
    quantityVariances: number
    priceVariances: number
    invoicesOnHold: number
    approvedPendingPayment: number
    ordersByStatus: StatusBucket[]
}

@Component({
    selector: 'app-purchasing-dashboard',
    templateUrl: './purchasing-dashboard.component.html',
    standalone: true,
    imports: [CommonModule, RouterLink],
})
export class PurchasingDashboardComponent extends BaseComponent implements OnInit {
    public metrics: PurchasingMetrics | null = null

    constructor() {
        super()
        this.isInitialLoading = false
    }

    ngOnInit(): void {
        this.services.data.http.get<PurchasingMetrics>('/api/PurchasingDashboard/GetMetrics').subscribe({
            next: result => (this.metrics = result),
            error: () => this.services.notification.error('Failed to load purchasing metrics'),
        })
    }
}
